var React = require('react');

function Auction (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.897 10.103a.76.76 0 0 1-1.074 1.074l-2.28-2.28a.76.76 0 1 1 1.074-1.074l2.726-2.726a.76.76 0 1 1 1.074-1.074l2.28 2.28a.76.76 0 0 1-1.074 1.074l-.826.826 4.94 4.94a.76.76 0 0 1-1.074 1.074l-4.94-4.94-.826.826zM3.8 14.44a.76.76 0 0 1 0-1.52h5.32a.76.76 0 0 1 0 1.52H3.8z","fill":"currentColor"}));
}

Auction.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = Auction;

Auction.default = Auction;
